// extracted by mini-css-extract-plugin
module.exports = {"news_box":"news_box-3DciADcS","news_top":"news_top-1tjVXPNV"};